<template>
  <el-table-column
    prop="is_supplier_contact"
    sortable
    label="Beszállítói"
    width="120"
  >
    <template slot-scope="scope">
      <el-tag size="small" v-if="scope.row.is_supplier_contact" type="success">
        Igen
      </el-tag>
      <el-tag v-else size="small" type="danger">
        Nem
      </el-tag>
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'is_supplier_contact',
  };
</script>
